/* eslint-disable func-names */
import { convert, Instant, nativeJs, ZonedDateTime } from "@js-joda/core";

declare global {
  module JSJoda {
    interface Instant {
      toDate(): Date;
    }
  }

  interface Date {
      toInstant(): Instant;
      toZonedDateTime(zoneId?: string): ZonedDateTime;
  }
}

Instant.prototype.toDate = function (): Date {
  return convert(this).toDate()
}

// eslint-disable-next-line no-extend-native
Date.prototype.toInstant = function (): Instant {
  return nativeJs(this).toInstant();
}

// eslint-disable-next-line no-extend-native
Date.prototype.toZonedDateTime = function (): ZonedDateTime {
  return nativeJs(this)
}